import i18n from 'i18next';
import { initReactI18next } from "react-i18next";
import { staticText } from './languages';

// Códigos usados pela aplicação (localStorage 'i18nextLng' e seletores de idioma).
// Os resources são registrados como 'pt', 'esp' e 'en', resolvidos pelo i18next
// via fallback de região (ex.: 'pt-BR' -> 'pt').
const SUPPORTED_LANGUAGES = ['pt-BR', 'esp-ES', 'en-US'];
const DEFAULT_LANGUAGE = 'pt-BR';

const detectBrowserLanguage = () => {
  const browserLanguages = (navigator.languages && navigator.languages.length)
    ? navigator.languages
    : [navigator.language];

  for (const browserLanguage of browserLanguages) {
    if (!browserLanguage) continue;
    const languageCode = browserLanguage.toLowerCase();
    if (languageCode.startsWith('pt')) return 'pt-BR';
    if (languageCode.startsWith('es')) return 'esp-ES';
    if (languageCode.startsWith('en')) return 'en-US';
  }

  return null;
};

const resolveInitialLanguage = () => {
  const savedLanguage = localStorage.getItem('i18nextLng');
  if (SUPPORTED_LANGUAGES.includes(savedLanguage)) {
    return savedLanguage;
  }
  return detectBrowserLanguage() || DEFAULT_LANGUAGE;
};

const initialLanguage = resolveInitialLanguage();

// Mantém o localStorage sempre com um código suportado: todo o restante da
// aplicação lê 'i18nextLng' diretamente e espera um destes três valores.
localStorage.setItem('i18nextLng', initialLanguage);

i18n
  .use(initReactI18next)
  .init({
    debug: false,
    defaultNS: ['translations'],
    lng: initialLanguage,
    fallbackLng: 'pt',
    ns: ['translations'],
    resources: staticText
  })

  export { i18n }
